<template>
  <div class="customize_form_wrapper">
    <el-skeleton :rows="3" :loading="isLoading">
      <el-form
        v-if="isShowForm"
        label-position="top"
        :model="form"
        ref="form"
        inline
        :disabled="disabled"
      >
        <el-row :gutter="40">
          <template v-for="(item, index) in schema">
            <el-col
              v-if="item.type !== 'textarea'"
              :key="index"
              :md="isFullScreen ? 6 : 12"
              :lg="6"
              :xl="6"
            >
              <el-form-item
                :style="item.style"
                :label="item.label"
                :rules="item.rules || []"
                :prop="item.key"
              >
                <el-input
                  v-if="item.type === 'Despace'"
                  v-model="form[item.key]"
                  onkeyup="value=value.replace(/[ ]/g,'')"
                />
                <el-input
                  v-else-if="item.type === 'input'"
                  v-model="form[item.key]"
                  @input="val => item.input && item.input(val, form)"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                />
                <el-select
                  clearable
                  filterable
                  remote
                  v-else-if="item.type === 'select'"
                  v-model="form[item.key]"
                  :placeholder="item.placeholder"
                  @change="val => item.change && item.change(val, form)"
                  :disabled="item.disabled"
                  :multiple="item.multiple"
                >
                  <el-option
                    v-for="(selectOption, index) in item.selectList"
                    :value="selectOption.id"
                    :key="index"
                    :label="selectOption.name || selectOption.state"
                  ></el-option>
                </el-select>
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-else-if="item.type === 'date'"
                  v-model="form[item.key]"
                  :disabled="item.disabled"
                  :picker-options="item.pickerOptions || {}"
                />
                <el-checkbox
                  v-else-if="item.type === 'checkbox'"
                  v-model="form[item.key]"
                />
              </el-form-item>
            </el-col>
            <el-col v-else :span="24" :key="index">
              <el-form-item
                :label="item.label"
                :rules="item.rules || []"
                :prop="item.key"
                class="plass"
                style="width: 100%; color: #000"
              >
                <el-input
                  v-if="item.type === 'textarea'"
                  type="textarea"
                  :rows="3"
                  v-model="form[item.key]"
                  :placeholder="item.placeholder"
                  :readonly="item.readOnly"
                  :show-word-limit="item.limit"
                  :disabled="item.disabled"
                />
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <slot></slot>
      </el-form>
      <el-row v-else>
        <template v-for="(item, index) in schema">
          <el-col
            :key="index"
            :md="isFullScreen ? 6 : 24"
            :lg="isFullScreen ? 6 : 12"
            :xl="6"
          >
            <div class="detail_item" :style="item.style">
              <template v-if="item.tooltip">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="`Update Time :${model[item.tooltip] || ''} `"
                  placement="top-start"
                >
                  <div style="display: inline-block">
                    <span class="label">{{ item.label }}：</span>
                    <span
                      class="value no-wrap"
                      :title="
                        Object.prototype.hasOwnProperty.call(
                          model,
                          item.key + 'Str',
                        )
                          ? model[item.key + 'Str']
                          : model[item.key]
                      "
                    >
                      {{
                        Object.prototype.hasOwnProperty.call(
                          model,
                          item.key + 'Str',
                        )
                          ? model[item.key + 'Str']
                          : model[item.key]
                      }}
                    </span>
                  </div>
                </el-tooltip>
              </template>
              <template v-else>
                <div>
                  <span class="label">{{ item.label }}：</span>
                  <span
                    class="value no-wrap"
                    :title="
                      Object.prototype.hasOwnProperty.call(
                        model,
                        item.key + 'Str',
                      )
                        ? model[item.key + 'Str']
                        : model[item.key]
                    "
                  >
                    {{
                      Object.prototype.hasOwnProperty.call(
                        model,
                        item.key + 'Str',
                      )
                        ? model[item.key + 'Str']
                        : model[item.key]
                    }}
                  </span>
                </div>
              </template>
            </div>
          </el-col>
        </template>
      </el-row>
      <el-row>
        <slot name="uploadSlot"></slot>
      </el-row>
      <el-row>
        <slot span="6" name="fileListSlot"></slot>
      </el-row>
      <el-row>
        <slot name="vagueSearch"></slot>
      </el-row>
    </el-skeleton>
  </div>
</template>

<script>
export default {
  name: 'customize-form',
  data() {
    return {
      form: {},
    }
  },
  created() {
    this.setForm({ ...this.defaultValues, ...this.model })
  },
  watch: {
    schema: {
      deep: true,
      immediate: true,
      handler(newValue) {
        newValue.forEach(item => {
          const key = item.key
          // amount的特殊处理
          if (key === 'amount') {
            this.$set(this.form, 'amount', item.value)
          }
          if (key === 'partialAmount') {
            this.$set(this.form, 'partialAmount', item.value)
          }
          if (key === 'requestAmount') {
            this.$set(this.form, 'requestAmount', item.value)
          }
          if (key === 'collateralAmount') {
            this.$set(this.form, 'collateralAmount', item.value)
          }
          if (key === 'insuranceAmount') {
            this.$set(this.form, 'insuranceAmount', item.value)
          }
          if (key === 'applicationAmount') {
            this.$set(this.form, 'applicationAmount', item.value)
          }
          if (key === 'relativeWeight') {
            this.$set(this.form, 'relativeWeight', item.value)
          }
          if (key === 'maxPaymentTerm') {
            this.$set(this.form, 'maxPaymentTerm', item.value)
          }
          // 这个判断主要处理，如果 model 比 schema 处理的早，schema 的 value 值就会覆盖 model的值
          if (!this.form[key]) {
            this.$set(this.form, key, item.value || '')
          }
        })
      },
    },
    model: {
      deep: true,
      immediate: false,
      handler(newValue) {
        if (this.isShowForm) {
          this.setForm(newValue)
        }
      },
    },
    isShowForm: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.setForm(this.model)
        }
      },
    },
  },
  props: {
    // 表单或者详情的数据结构模型
    schema: {
      type: Array,
      default: () => [],
    },
    // 是否显示表单
    isShowForm: {
      type: Boolean,
      default: true,
    },
    // 数据
    model: {
      type: Object,
      default: () => {},
    },
    // 默认值
    defaultValues: {
      type: Object,
      default: () => {},
    },
    // 是否显示骨架屏
    isLoading: {
      type: Boolean,
      default: false,
    },
    // 页面是否是全屏（客户信息里边需要减去左边菜单的宽度做自适应）true: 是 false：不是
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getFormData() {
      return { ...this.form }
    },
    reset(key) {
      if (key) {
        this.$refs.form.resetFields(key)
        return
      }
      this.$refs.form.resetFields()
    },
    async validateFields() {
      return await this.$refs.form.validate()
    },
    setForm(data) {
      Object.keys(data).forEach(key => {
        this.$set(this.form, key, data[key])
      })
    },
  },
}
</script>

<style scoped lang="scss">
.el-select,
.el-input {
  width: 100%;
}
.el-textarea {
  width: 100%;
}
.el-form-item {
  width: 100%;
  text-align: left;
}
:deep(.el-textarea.is-disabled .el-textarea__inner) {
  color: #000 !important;
}
.detail_item {
  font-size: 14px;
  color: #000;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 10px;
  .label {
    display: inline-block;
    font-size: 14px;
    color: #000;
    line-height: 30px;
  }
  .value {
    font-size: 14px;
    color: #3a3f63;
    display: inline-block;
  }
  .no-wrap {
    max-width: 260px;
    vertical-align: bottom;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.m_p {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  .m_key {
    font-size: 14px;
    margin-right: 14px;
  }
  .m_value {
    font-size: 14px;
  }
}
</style>
